import React, { Fragment, forwardRef, useRef, useState, useContext, useEffect } from 'react';
// import {  Link  } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Typography, TextField, Button, CircularProgress, Paper, Stepper, Step, StepLabel, StepConnector, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Slide } from '@material-ui/core';
import green from '@material-ui/core/colors/green';

import useForm from 'hooks/useForm';
import clsx from 'clsx';
import { Icon } from 'styles';

import { I18nManagerContext } from 'contexts/I18nManager';
import PatientInsuranceForm from 'components/PatientInsuranceForm'
import BillingInfoForm from 'components/BillingInfoForm'
import AuthContactForm from 'components/AuthContactForm'

const useStyles = makeStyles(theme => ({
    dialogPaper: {
        width: '80%',
        maxWidth: 600
    },

    root: {
        flexGrow: 1,
        
        boxShadow: 'none',
        border: '1px solid #E2E2E3',
        borderRadius: 2,

        display: 'flex',
        alignItems: 'stretch',
        flexDirection: 'column',
        justifyContent: 'stretch'
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(5) ,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(0)
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignItems: 'stretch',
        flexGrow: 1,
        padding: theme.spacing(5),
        paddingTop: theme.spacing(4)
    },
    titleContainer: {
        flex: 1
    },
    title: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
            display: 'block',
            padding: 0
        // },
    },
    subtitle: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
            display: 'block',
            paddingLeft: theme.spacing(1/4)
        // },
    },
    content: {
        // paddingTop: 8,
        paddingLeft: 75,
        paddingRight: 75
    },
    step: {
        height: '100%',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        // paddingTop: 20
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '45%'
    },
    textField: {
        width: theme.spacing(41)
    },
    actions: {
        
    },
    buttons: {
        marginTop: theme.spacing(5),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        width: theme.spacing(19.5),
        marginLeft: theme.spacing(1)/2,
        marginRight: theme.spacing(1)/2,
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -theme.spacing(1) - 4,
        marginLeft: -theme.spacing(1) - 4
    }
}))

const QontoConnector = withStyles({
    alternativeLabel: {
      right: 'calc(50% + 30px)',
    },
    active: {
      '& $line': {
        borderColor: '#4CB0AC',
        borderTopWidth: 1
      },
    },
    completed: {
      '& $line': {
        borderColor: '#4CB0AC',
      },
    },
    line: {
      borderColor: '#E9E9F0',
      borderTopWidth: 1,
      borderRadius: 1
    },
  })(StepConnector);

  const useQontoStepIconStyles = makeStyles({
    root: {
      color: '#4CB0AC',
      display: 'flex',
      height: 22,
      alignItems: 'center',
      fontSize: 15
    },
    active: {
      color: '#4CB0AC'
    },
    circle: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        color: 'rgba(0, 0, 0, 0.3)',
        borderRadius: 100,
        width: '2.5em',
        height: '2.5em',
        textAlign: 'center',
        lineHeight: '2.4em'
    },
    circleActive: {
        border: '1px solid #4CB0AC',
        backgroundColor: '#4CB0AC',
        color: 'white',
        borderRadius: 100,
        width: '2.5em',
        height: '2.5em',
        textAlign: 'center',
        lineHeight: '2.4em'
    },
    completed: {
        borderRadius: 100,
        backgroundColor: '#4CB0AC',
        width: '2.5em',
        height: '2.5em',
        textAlign: 'center',
        lineHeight: '2.4em'
    },
  });
  
  function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed, icon } = props;
  
    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
        {completed ? <div className={classes.completed}><Icon icon="check" size={20} /></div> : active ? <div className={classes.circleActive}> { icon } </div> : <div className={classes.circle}> { icon } </div>}
        
      </div>
    );
  }
  
  QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
  };

//TODO: localize
const Steps = [
    { label: 'Membership', component: PatientInsuranceForm },
    { label: 'Billing', component: BillingInfoForm },
    { label: 'Contact', component: AuthContactForm }
]

function getSteps() {
    return Steps.map(step => step.label)
}
  
function StepComponent({ activeStep, ...others }) {
    const Component = Steps[activeStep].component
    return (
        <Component {...others} />
    ) 
}

const InputLabelProps = { 
    required: false //Hide asterix on required field
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

function PatientInsuranceStepper({ open, params = {}, title, subtitle, record, resource, fetchRecord, inProgress, onSubmit, onCancel }) {
    const i18nManager = useContext(I18nManagerContext)
    const classes = useStyles()
    const [isSubmitting, setSubmitting] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const steps = getSteps()
    const [state, setState] = useState(record || { country: 'US' })
    // const { params } = match

    useEffect(() => {
        if (params && params.id) {
            fetchRecord(Object.assign(resource, { params }))
        }
    }, [resource])

    // useEffect(() => {
    //     setState({ ...record })
    // }, [record])

    const handleCancel = () => {
        onCancel()
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleError = () => {
        setSubmitting(false)   
    }

    const handleContinue = event => {
        event.preventDefault()
        setSubmitting(true)
    }

    const handleSubmit = newState => {
        setSubmitting(false)
        // setState(prevState => Object.assign(prevState, {...newState}))
        setState({...newState})
        if (activeStep < steps.length - 1) {
            setActiveStep(prevActiveStep => prevActiveStep + 1)
        }
        else {
            onSubmit(newState)
        }
    }

    return (
        <Dialog 
            classes={{
                paper: classes.dialogPaper
            }}
            open={open} 
            onClose={onCancel} 
            aria-labelledby="form-dialog-title"
            TransitionComponent={Transition}
            keepMounted
            disableBackdropClick
            disableEscapeKeyDown
        >
            <DialogTitle id="form-dialog-title">
                {i18nManager.t(title)}
                <Typography className={classes.subtitle} variant="caption" color="textSecondary" noWrap>
                    {i18nManager.t(subtitle)}
                </Typography> 
                <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper> 
            </DialogTitle>
            <DialogContent className={classes.content}>               
                <div className={classes.step}>
                    <StepComponent 
                        activeStep={activeStep} 
                        params={params}
                        record={state}
                        isSubmitting={isSubmitting}
                        onSubmit={handleSubmit}
                        onError={handleError}
                    />
                </div>
            </DialogContent>
            <DialogActions className={classes.buttons}>
                <Button variant="contained" className={classes.button} onClick={handleCancel}>Cancel</Button>
                    {(activeStep > 0 && activeStep < steps.length) && (
                        <Button variant="contained" className={classes.button} onClick={handleBack}>Back</Button>
                    )}
                <Button variant="contained" className={classes.button} onClick={handleContinue} color="secondary">
                    {(activeStep < steps.length - 1) ? "Continue" : "Finish"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

PatientInsuranceStepper.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default PatientInsuranceStepper